import { isDefined } from "@clipboard-health/util-ts";
import { isCapacitorPlatform, useAppInfo } from "@src/appV2/lib";
import { type TouchpointIntegrationConfig } from "@src/appV2/Shifts/Shift/ShiftState/types";

import { isEnabledForAppVersionAndOta } from "../../utils/isSolveUnpaidBreaksFeatureEnabled";

const DEFAULT_TIME_TO_ALLOW_SKIP_IN_SEC = 90;

export interface TouchpointIntegrationConfigEnabledValue {
  kioskLocation: string;
  agencyId: number;
  agencyName: string;
  isWebhookOn: boolean;
  timeToAllowSkipInSec: number;
}

export function useIsTouchpointIntegrationEnabled(props: {
  integrationConfig?: TouchpointIntegrationConfig;
}): TouchpointIntegrationConfigEnabledValue | undefined {
  const { integrationConfig } = props;
  const { appInfo } = useAppInfo();

  if (!isDefined(integrationConfig)) {
    return undefined;
  }

  const { asAgencyId, asAgencyName, kioskLocation, isWebhookOn, minVersion, timeToAllowSkipInSec } =
    integrationConfig;

  if (
    isCapacitorPlatform() &&
    minVersion &&
    appInfo &&
    !isEnabledForAppVersionAndOta({
      minimalOtaVersion: minVersion.ota,
      minimalStoreVersion: minVersion.store,
      appInfo,
    })
  ) {
    return undefined;
  }

  return {
    kioskLocation,
    agencyId: asAgencyId,
    agencyName: asAgencyName,
    isWebhookOn: isWebhookOn ?? true,
    timeToAllowSkipInSec: timeToAllowSkipInSec ?? DEFAULT_TIME_TO_ALLOW_SKIP_IN_SEC,
  };
}
